import React, { Component } from 'react'
import './SocialFooter.scss'
import linkedinLogo from '../../assets/img/icons/linkedin.svg'

export class SocialFooter extends Component {

  render() {
    return (
      <div className="m-social-footer">
        <a className="m-social-footer__item m-social-footer__item--linkedin"
          href="https://www.linkedin.com/company/enkiai/" target="_blank" rel="noopener noreferrer">
          <img src={linkedinLogo} alt="Linkedin Page" />
        </a>
      </div>
    )
  }
}

export default SocialFooter
